<template>
  <div>
    <b-form class="mt-2" @submit="onSubmit">
      <b-row>
        <b-col md="4">
          <b-form-group
            :id="selectGroupID"
            label="Assign a lead"
            :label-for="selectID"
          >
            <b-form-select
              :id="selectID"
              v-model="ofditLead"
              :options="ofditStaff"
              text-field="full_name"
              value-field="full_name"
            />
          </b-form-group>
        </b-col>
        <b-col md="8">
          <b-form-group
            :id="textGroupID"
            label="OFDIT notes"
            :label-for="textID"
          >
            <b-form-textarea
              :id="textID"
              v-model="ofditApprovalNotes"
              rows="4"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row align-h="end">
        <b-button class="mr-3" type="submit" variant="primary">Submit</b-button>
      </b-row>
    </b-form>
  </div>
</template>

<script>
  export default {
    name: 'GAssignLeadsForm',
    props: { project: Object },
    data() {
      return {
        ofditLead: this.project.ofdit_lead,
        additionalComment: '',
        selectGroupID: 'lead-select-group-' + this.project.id,
        selectID: 'lead-select-' + this.project.id,
        textGroupID: 'lead-text-group-' + this.project.id,
        textID: 'lead-text-' + this.project.id,
        ofditApprovalNotes: this.project.ofdit_notes,
        changedLead: false
      }
    },
    computed: {
      ofditStaff() {
        return this.$store.getters.ofditStaff
      }
    },
    methods: {
      async onSubmit() {
        const payload = {
          ofdit_lead: this.ofditLead,
          project_id: this.project.id,
          status: 'OFDIT approval',
          ofdit_notes: this.ofditApprovalNotes
        }
        if (this.project.ofdit_lead !== this.ofditLead) {
          this.changedLead = true
        }
        try {
          await this.$store.dispatch('updateProjectStatus', payload)
          if (this.changedLead) {
            await this.$store.dispatch('updateProjectLead', payload)
          }
          this.$bvToast.toast(
            `Aye, Aye Captain \n\nOFDIT approval recorded for project ${this.project.id}/${this.project.course}.`,
            {
              title: 'Success',
              autoHideDelay: 1000,
              toaster: 'b-toaster-top-center',
              variant: 'success'
            }
          )
        } catch (err) {
          this.$bvToast.toast(`${err}`, {
            title: 'Unsuccessful',
            toaster: 'b-toaster-top-center',
            variant: 'danger'
          })
        }
      }
    }
  }
</script>

<style scoped></style>
